/*
 * COPYRIGHT (c) 2024
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from '@scuf/localization';

import descriptors from '../../../locales/en-US/descriptors';

import './UtilityBaselineSettingsTheme.scss';
import {
  UtilityMetersBaselineTable,
  UtilityMetersBaselineTableWithLoader
} from './UtilityMetersTable/UtilityMetersTable';
import useConnectorAndDynamicProps from '../../shared/useConnectorAndDynamicProps/useConnectorAndDynamicProps';
import {
  IAny,
  IRequestContext
} from '../../DashboardKPIWidgets/IEnergyManagementProps';
import useMounted from '../../shared/useMount/useMount';
import { ApiContext } from '../../../context/ApiContext';
import { IUtilityMeterBaselineStatus } from '../BaselineConfigurationModels';

interface IUtilityBillBaselineSettingsProps {
  requestContext: IRequestContext;
}

const UtilityBillBaselineSettings: React.FC<IUtilityBillBaselineSettingsProps> = (
  props: IUtilityBillBaselineSettingsProps
) => {
  const { requestContext } = props;

  const e = descriptors.energyManagement;
  const [t] = useTranslation();

  const connectorConfig = {
    name: 'get-utility-meter-list'
  };

  // const [meterListDataconnector] = useConnectorAndDynamicProps({
  //   connectorConfig,
  //   requestContext
  // });
  // const onRefresh = () => meterListDataconnector?.actions?.getAll();

  // const isMounted = useMounted();

  // const { all, loading, error, status } = meterListDataconnector.data;
  // const utilityMeterListData = (all as unknown) as IAny;
  // const isDataAvailable = utilityMeterListData ? true : false;

  // const [isLoading, setIsLoading] = useState<boolean>(loading);
  // const [statusCode, setStatusCode] = useState<number | null>(0);
  // const [errorInfo, setErrorInfo] = useState(error);
  // const [meterListData, setData] = useState<any>([]);

  // useEffect(() => {
  //   setIsLoading(loading);
  //   if ((isDataAvailable || error || status) && !loading) {
  //     if (isDataAvailable) {
  //       setData(utilityMeterListData);
  //     }
  //     setErrorInfo(error);
  //     setStatusCode(status);
  //   }
  // }, [isDataAvailable, loading, status, utilityMeterListData]);

  /** Mock */
  const meterList: IUtilityMeterBaselineStatus[] = [
    {
      baselineDetails: null,
      meterId: '1',
      lastTrained: null,
      meterName: 'Meter 1',
      utilityType: 'Electricity'
    },
    {
      baselineDetails: {
        quality: 'Good',
        qualityDescription: 'Almost perfect match',
        baselinePeriodEnd: new Date(),
        baselinePeriodStart: new Date('01 Jan 2024'),
        metrics: [
          {
            name: 'R2',
            value: 0.82,
            unit: null
          },
          {
            name: 'SMAPE',
            value: 2.98,
            unit: '%'
          },
          {
            name: 'Cv(RMSE)',
            value: 5.75,
            unit: '%'
          },
          {
            name: 'MBE',
            value: 0.05,
            unit: '%'
          }
        ]
      },
      meterId: '2',
      lastTrained: new Date(),
      meterName: 'Meter 2',
      utilityType: 'Electricity'
    }
  ];

  return (
    <div className="utility-bill-baseline-meters-table">
      {/* <UtilityMetersBaselineTableWithLoader
        loading={isLoading}
        error={errorInfo}
        statusCode={statusCode}
        onRefresh={onRefresh}
        meterList={meterListData}
        loadingText={t(e.LOADING)}
        title={t(e.CONNECTIONERRORTITLE)}
        noDataMessage={t(e.NODATAAVAILABLE)}
        connectionErrorMessage={t(e.CONNECTIONERROR)}
      /> */}
      <UtilityMetersBaselineTable meterList={meterList} />
    </div>
  );
};

export default UtilityBillBaselineSettings;
